var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusIp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114.43 114.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#666;stroke-miterlimit:10;stroke-width:3px;}.cls-2{fill:#666;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Risorsa 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 57.22,
    cy: 57.22,
    r: 55.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.66,61.42a4.27,4.27,0,0,1-4.21,4.21H65.63V82.45a4.27,4.27,0,0,1-4.21,4.21H53a4.27,4.27,0,0,1-4.21-4.21V65.63H32a4.27,4.27,0,0,1-4.2-4.21V53a4.25,4.25,0,0,1,4.2-4.2H48.81V32a4.25,4.25,0,0,1,4.2-4.2h8.41A4.27,4.27,0,0,1,65.63,32V48.81H82.45A4.25,4.25,0,0,1,86.66,53Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIp);
export default __webpack_public_path__ + "static/media/plus_ip.f562402662e7737c48a3c52d729a45fb.svg";
export { ForwardRef as ReactComponent };